<template>
  <div v-if="show">
    <v-dialog v-model="showing" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{message}}
          <v-progress-linear indeterminate color="white" class="mb-0"/>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "spinner",
  props: ["show", "message"],
  data() {
    return {
      showing: true
    };
  }
};
</script>
<style>
</style>
